import _defineProperty from "/Users/mac/Desktop/Personal-Website-master/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/mac/Desktop/Personal-Website-master/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/mac/Desktop/Personal-Website-master/node_modules/@babel/runtime/helpers/esm/createClass";
import { Emitter } from './emitter';
import { mapValues } from './utils';
/**
 * Immutable snapshot of the current store state. One StoreSnapshot per
 * StoreDefinition is usually alive at a time.
 */

export var StoreSnapshot =
/*#__PURE__*/
function () {
  function StoreSnapshot(state, storeDefinition) {
    _classCallCheck(this, StoreSnapshot);

    this.state = state;
    this.storeDefinition = storeDefinition;
  }

  _createClass(StoreSnapshot, [{
    key: "get",
    value: function get(key) {
      return this.state[key];
    }
  }, {
    key: "set",
    value: function set(key) {
      return this.storeDefinition.set(key);
    }
  }, {
    key: "setFrom_EXPERIMENTAL",
    value: function setFrom_EXPERIMENTAL(f) {
      return this.storeDefinition.setFrom_EXPERIMENTAL(f);
    }
  }, {
    key: "on",
    value: function on(key) {
      return this.storeDefinition.on(key);
    }
  }, {
    key: "onAll",
    value: function onAll() {
      return this.storeDefinition.onAll();
    }
  }, {
    key: "getState",
    value: function getState() {
      return Object.freeze(this.state);
    }
  }]);

  return StoreSnapshot;
}();
var DEFAULT_OPTIONS = {
  isDevMode: false
};
/**
 * We create a single instance of this per <Container />.
 */

export var StoreDefinition =
/*#__PURE__*/
function () {
  function StoreDefinition(state, options) {
    var _this = this;

    _classCallCheck(this, StoreDefinition);

    // Initialize emitters
    this.alls = new Emitter(options.isDevMode);
    this.emitter = new Emitter(options.isDevMode); // Set initial state

    this.storeSnapshot = new StoreSnapshot(state, this); // Cache setters

    this.setters = mapValues(state, function (v, key) {
      return function (value) {
        var previousValue = _this.storeSnapshot.get(key);

        _this.storeSnapshot = new StoreSnapshot(Object.assign({}, _this.storeSnapshot.getState(), _defineProperty({}, key, value)), _this);

        _this.emitter.emit(key, value);

        _this.alls.emit(key, {
          key: key,
          previousValue: previousValue,
          value: value
        });
      };
    });
  }

  _createClass(StoreDefinition, [{
    key: "on",
    value: function on(key) {
      return this.emitter.on(key);
    }
  }, {
    key: "onAll",
    value: function onAll() {
      return this.alls.all();
    }
  }, {
    key: "get",
    value: function get(key) {
      return this.storeSnapshot.get(key);
    }
  }, {
    key: "set",
    value: function set(key) {
      return this.setters[key];
    }
  }, {
    key: "setFrom_EXPERIMENTAL",
    value: function setFrom_EXPERIMENTAL(f) {
      return f(this.storeSnapshot);
    }
  }, {
    key: "getCurrentSnapshot",
    value: function getCurrentSnapshot() {
      return this.storeSnapshot;
    }
  }, {
    key: "toStore",
    value: function toStore() {
      return this.storeSnapshot;
    }
  }, {
    key: "getState",
    value: function getState() {
      return this.storeSnapshot.getState();
    }
  }]);

  return StoreDefinition;
}();
/**
 * @deprecated Use `createConnectedStore` instead.
 */

export function createStore(initialState) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_OPTIONS;
  return new StoreDefinition(initialState, options);
}
export * from './plugins/withLogger';
export * from './plugins/withReduxDevtools';
export * from './react';